import {Link as RouterLink, matchRoutes, NavLink as RouterNavLink, resolvePath} from '@github-ui/react-router'
import {ssrSafeLocation} from '@github-ui/ssr-utils'
import {type ReactElement, use} from 'react'

import {PREVENT_AUTOFOCUS_KEY} from './prevent-autofocus'
import {RoutesContext} from './routes-context'

type PreventAutofocusProp = {preventAutofocus?: boolean}

export const Link = ({
  to,
  reloadDocument,
  preventAutofocus,
  ...props
}: React.ComponentProps<typeof RouterLink> & PreventAutofocusProp): ReactElement => {
  const {routes} = use(RoutesContext)
  const pathname = resolvePath(to, ssrSafeLocation.pathname).pathname
  reloadDocument = reloadDocument ?? !matchRoutes(routes, pathname)
  return (
    <RouterLink
      to={to}
      {...props}
      state={
        preventAutofocus
          ? {
              [PREVENT_AUTOFOCUS_KEY]: true,
              ...props.state,
            }
          : props.state
      }
      reloadDocument={reloadDocument}
    />
  )
}

Link.displayName = 'Link'

export function NavLink({
  to,
  reloadDocument,
  preventAutofocus,
  ...props
}: React.ComponentProps<typeof RouterNavLink> & PreventAutofocusProp): React.ReactElement {
  const {routes} = use(RoutesContext)
  const pathname = resolvePath(to, ssrSafeLocation.pathname).pathname
  reloadDocument = reloadDocument ?? !matchRoutes(routes, pathname)
  return (
    <RouterNavLink
      to={to}
      {...props}
      state={
        preventAutofocus
          ? {
              [PREVENT_AUTOFOCUS_KEY]: true,
              ...props.state,
            }
          : props.state
      }
      reloadDocument={reloadDocument}
    />
  )
}
